<template>
  <div>
    <div class="box">
      <h5>Hi {{userName}}~ <br> {{$t('FoodC_remark_Enjoy_your_OvmD' /*祝您用餐愉快*/)}}</h5>
      <p>{{$t('FoodC_remark_Thank_you_ENoY', {brand_name: 'DiDi Food'} /*感谢你使用didifood*/)}}</p>
      <img class="msg_img" src="../Evaluate/imgs/icon_5.png" alt="pic">
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluateWelcome',
  props: {
    userName: String,
  }
}
</script>

<style lang="scss" scoped>
.box {
  text-align: center;
  color: #000;
  line-height: 1;
  h5 {
    font-family: 'Aspira Medium';
    font-weight: 500;
    font-size: 24px;
    font-weight: 500;
    line-height: 27px;
  }
  p {
    line-height: 1;
    padding-top: 12px;
    text-align: center;
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: 14px;
  }
  .msg_img {
    width: 257px;
    height: 200px;
  }
}
</style>
